import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MutateFn } from '@diritto/common/base/mutateFunction';
import { ContentContestEditDto } from '@diritto/common/contest/dtos/contest.request.dto';
import { ContestApi } from '@/api/ApiHelper';
import { contestsQueryKey } from '@/queries/contests/queryKey';

export const useContentContestMutation = (callback?: MutateFn) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ contestId, payload }: { contestId: number; payload: ContentContestEditDto }) =>
      ContestApi.addContestContent(contestId, payload),
    ...callback,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: contestsQueryKey.myContestContents(variables.contestId) });
      callback?.onSuccess?.(data, variables);
    },
  });
};
